import VendorScreen from './index';

const routes = [
  {
    path: '/master/vendor',
    component: VendorScreen,
    action: ['manage', 'read_only'],
    service: ['nvo.platform.partner'],
  },
];

export default routes;
